<canvas #lineChart style="width: 467px; height: 161px"></canvas>
